import React from 'react'
import { FaComment } from 'react-icons/fa'
import { firestore } from '../../firebase/firebase-utils'
import { withRouter } from 'react-router-dom'

const Comment = (props) => {
    const [comments, setComments] = React.useState([]);

    React.useEffect(() => {
        firestore.collection(props.collection).doc(props.docid).onSnapshot((feed) => {
            if (feed.exists) {
                var query = feed.data().comments;
                if (query) {
                    setComments(query)
                }
            }
        })
    }, [props.docid, props.collection])

    const PostComment = () => {
        if (comments) {
            props.history.push('/community/' + props.docid)
        }
    }

    return (
        props.collection === "queries" ?
        <><FaComment onClick={PostComment} />{'  '}<span>{comments.length}</span></>
        :
        <><FaComment />{'  '}<span>{comments.length}</span></>
    )
}

export default withRouter(Comment)
